/* eslint-disable no-alert */
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from '@material-ui/core';
import { Stack } from '@superdispatch/ui';
import { Box, Button, DescriptionItem } from '@superdispatch/ui-lab';
import {
  BaseMobileAppInterface,
  getMobileAppToken,
  WebkitMessageHandlerPayload,
  MobileAppBridge,
  AndroidMobileAppInterface,
} from 'shared/data/MobileAppBridge';
import { WebviewLayout } from 'shared/layout/WebviewLayout';

const methods: Array<
  [
    android: keyof AndroidMobileAppInterface,
    ios: WebkitMessageHandlerPayload['type'] | keyof BaseMobileAppInterface,
    fn: () => void,
  ]
> = [
  ['openProfile', 'open_profile', () => MobileAppBridge.openProfile()],
  ['openSettings', 'open_settings', () => MobileAppBridge.openSettings()],
  [
    'openDriverInformation',
    'open_driver_information',
    () => MobileAppBridge.openDriverInformation(),
  ],
  [
    'openCarrierInformation',
    'open_carrier_information',
    () => MobileAppBridge.openCarrierInformation(),
  ],
  [
    'openExternalUrl',
    'open_external_url',
    () => MobileAppBridge.openExternalUrl('https://google.com'),
  ],
  [
    'openACHPaymentInformation',
    'open_ach_payment_information',
    () => MobileAppBridge.openACHPaymentInformation(),
  ],
  [
    'openAvailableLoads',
    'open_available_loads',
    () => MobileAppBridge.openAvailableLoads(),
  ],
  [
    'openVerifiedCarrierPromotionalModal',
    'open_verified_carrier_promotional_modal',
    () => MobileAppBridge.openVerifiedCarrierPromotionalModal(),
  ],
  [
    'openUnverifiedCarrierRequestWallModal',
    'open_unverified_carrier_request_wall_modal',
    () => MobileAppBridge.openUnverifiedCarrierRequestWallModal(),
  ],
  [
    'openDriverPreferences',
    'open_driver_preferences',
    () => MobileAppBridge.openDriverPreferences(),
  ],
  [
    'acceptedShipperLimitedExperience',
    'accepted_shipper_limited_experience',
    () => MobileAppBridge.acceptShipperLimitedExperience(true),
  ],
  ['closeScreen', 'close_screen', () => MobileAppBridge.closeScreen()],
  [
    'getToken',
    'getToken',
    () => {
      alert(window.MobileLoadboardInterface?.getToken?.());
    },
  ],
  [
    'getDriverGuid',
    'getDriverGuid',
    () => {
      alert(window.MobileLoadboardInterface?.getDriverGuid?.());
    },
  ],
  [
    'getDeviceGuid',
    'getDeviceGuid',
    () => {
      alert(window.MobileLoadboardInterface?.getDeviceGuid?.());
    },
  ],
  [
    'getCarrierGuid',
    'getCarrierGuid',
    () => {
      alert(window.MobileLoadboardInterface?.getCarrierGuid?.());
    },
  ],
  [
    'getFeatureToggles',
    'getFeatureToggles',
    () => {
      alert(JSON.stringify(MobileAppBridge.getFeatureToggles()));
    },
  ],
  [
    'isDarkMode',
    'isDarkMode',
    () => {
      alert(String(window.MobileLoadboardInterface?.isDarkMode?.()));
    },
  ],
  [
    'isOnboardingEnabled',
    'isOnboardingEnabled',
    () => {
      alert(String(window.MobileLoadboardInterface?.isOnboardingEnabled?.()));
    },
  ],
  [
    'getAppVersion',
    'getAppVersion',
    () => {
      alert(MobileAppBridge.getAppVersion() || 'No version available');
    },
  ],
  [
    'updateSuggestedLoads',
    'update_suggested_loads',
    () => MobileAppBridge.updateSuggestedLoads({ unseen_count: 2 }),
  ],
];

export function MobileInterfaceTestPage() {
  const theme = useTheme();
  const token = getMobileAppToken();

  return (
    <WebviewLayout>
      <Stack>
        <Box padding="small">
          <DescriptionItem label="Has token:">
            {token ? 'Yes' : 'No'}
          </DescriptionItem>
        </Box>

        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Android</TableCell>
                <TableCell>IOS</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {methods.map(([android, ios, fn], index) => (
                <TableRow key={index}>
                  <TableCell>{android}</TableCell>
                  <TableCell>{ios}</TableCell>
                  <TableCell>
                    <Button
                      onClick={() => {
                        fn();
                      }}
                    >
                      Call
                    </Button>
                  </TableCell>
                </TableRow>
              ))}

              <TableRow>
                <TableCell>driver_app_theme_mode_changed</TableCell>
                <TableCell>driver_app_theme_mode_changed</TableCell>
                <TableCell>
                  <Button
                    onClick={() => {
                      const event = new CustomEvent(
                        'driver_app_theme_mode_changed',
                        {
                          detail: { isDarkMode: theme.palette.type !== 'dark' },
                        },
                      );
                      window.dispatchEvent(event);
                    }}
                  >
                    Call
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </WebviewLayout>
  );
}
